import React from 'react';
import TextInput from './TextInput';
const NumberInput = props => {
    return React.createElement(TextInput, { ...props });
};
export default NumberInput;
